export const disabledButtonStyles = {
  '&.Mui-disabled': {
    border: '2px solid #d6d6d6',
    color: '#b0b0b0',
    backgroundColor: '#f0f0f0',
    cursor: 'not-allowed',
    opacity: 0.6,
  },
};
